import { render, staticRenderFns } from "./InfoObstacle.vue?vue&type=template&id=de805294&scoped=true&"
import script from "./InfoObstacle.vue?vue&type=script&lang=js&"
export * from "./InfoObstacle.vue?vue&type=script&lang=js&"
import style0 from "./InfoObstacle.vue?vue&type=style&index=0&id=de805294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de805294",
  null
  
)

export default component.exports